export default {
    common: {
        email: 'Correo electrónico',
        LoginBtn: 'Iniciar sesión',
        SignUpBtn: 'Regístrate',
        SubmitBtn: 'Enviar',
        ExitBtn: 'Salir de',
        LogoutBtn: 'Cerrar sesión'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Por favor, compruebe su correo electrónico para el código de verificación.',
        VerificationCode: 'Código de verificación'
    },
    header: {
        OrderHistory: 'Historial de pedidos',
        MYACCOUNT: 'MI CUENTA',
        WelcomeBack: 'Bienvenido'
    },
    detail: {
        TotalOrders: 'Pedidos totales',
        TotalProducts: 'Productos totales',
        WonderlandPoints: 'Puntos Wonderland',
        APMCredits: 'APM Crédito',
        ExpireOn: 'Expiración',
        NoAPMCredits: 'No hay crédito apm',
        CreditsLoading: 'Carga de créditos'
    },
    panel: {},
    entry: {
        Client: 'Cliente',
        OrderDate: 'Fecha de pedido',
        DeliverDate: 'Fecha de entrega',
        Description: 'Descripción',
        Total: 'Total'
    },
    board: {
        Order: 'Pedido',
        Date: 'Fecha',
        Total: 'Total'
    },
    order: {
        OrderID: 'ID Pedido',
        PurchasePlace: 'Ubicación',
        PurchaseDate: 'Fecha de compra',
        TotalPrice: 'Precio total',
    },
    product: {
        Name: 'Nombre',
        SKU: 'SKU',
        Size: 'Talla',
        Quantity: 'Cantidad',
        Price: 'Precio',
        WarrantyUntil: 'Garantía hasta',
    }
}


// WEBPACK FOOTER //
// ./src/locales/es/index.js